import Dropdown from "react-bootstrap/esm/Dropdown";
import { FC } from "react";
import { IPageAction } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import { Property } from "../../../base/types";
import { useGetProperties } from "../../../base/hooks";

interface IActionDropdownLinkProps {
    action: IPageAction
}

export const ActionDropdownLink: FC<IActionDropdownLinkProps> = ({
    action
}) => {
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageUrl: string | undefined = properties[Property.Url];
    const target: string = properties[Property.Target];

    if (!pageUrl)
        return <Dropdown.ItemText>{action.name}</Dropdown.ItemText>

    return (
        <Dropdown.Item
            target={target || undefined}
            href={pageUrl}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </Dropdown.Item>
    )
}